var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('cookie-law',{attrs:{"theme":"afterlife","buttonText":_vm.$t('message.cookiePopup.ok'),"message":_vm.$t('message.cookiePopup.message'),"position":"bottom","transitionName":"fade"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1eac71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CookiePopup.vue
// module id = ArdV
// module chunks = 1